export type GetPartnerResponse = {
  ptnrId: string;
  ptnrCd: string;
  ptnrName: string;
  ptnrNameWtngChng: string;
  ptnrTypeCd: string;
  ptnrTypeName: string;
  buCnTypeCd: string;
  buCnTypeName: string;
  buCd: string;
  cnCd: string;
  dipByRgn: string;
  cpntId: string;
  delFlg: string;
  updtDtimePtnr: string;
  chnTypeList: {
    inOutTypeCd: string;
    inOutTypeName: string;
    chnTypeCd: string;
    chnTypeName: string;
    fileTypeCd: string;
    fileTypeName: string;
    chnTypeDelFlg: string;
    updtDtimePtnrChnType: string;
  }[];
};
